/**
 * Created by comoon on 3/2/16.
 */

var React = require('react');

var ReactDOM = require('react-dom');

var $ = require("jquery");

var _ = require("underscore");

var moment = require("moment");

var QuoteApplyForm = require("./QuoteApplyForm.jsx");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var QuoteStatus = require("../conf/quote-status");

var OrderTarget = require("../conf/order-target");

var OrderStatus = require("../conf/order-status");

var TripGrade = require("../conf/trip-grade");

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var {object2class} = require("../util/clazz");

var {format} = require("../util/price");

var Countdown = require("../cutil/Countdown");

var PriceRatioButton = ()=>
    <a href="https://www.xcds.com.cn/topic/special/price_ratio_h5/?rf=zhunaa" className="btn-blue btn-price-ratio" target="_blank">
        <i className="icon icon-m-product-price-ratio"></i>
        全网比价，超全攻略
    </a>


/**
 * 计价列表倒计时
 */
var QuoteCountdown = ({quote,onInvalid})=>
    <span className="cell-count-down">
            <i className="icon-product-timer"></i>
            <Countdown left={ALikeStore.get_recordInvalidSeconds(quote.inquiryKey)}
                       onInvalid={ onInvalid } data={quote}/>内有效
    </span>



var hasCountdown = (quote)=>{

    var version = ALikeStore.get_recordDefaultVersion(quote.inquiryKey, true);

    if ( version.valid && !quote.isExpired ) {
        return true
    }else{
        return false
    }

}

var CATEGORY_MIN = 1;
var CATEGORY_MAX = 7;
var CATEGORY_STEP = 1;
var SELLER_MIN = 6;
var SELLER_MAX = 4888;
var SELLER_STEP = 70;
var PRODUCT_MIN = 45;
var PRODUCT_MAX = 100000;
var PRODUCT_STEP = 1700;

module.exports = React.createClass({
    displayName: "QuoteRecordList",
    getInitialState(){
        var props = this.props;
        var trip = ALikeStore.get_tripBasicInfo();
        var userRole = trip.userRole || 0;  //1: 达人, 2: 小帮手,0: 其他
        return {
            categories: CATEGORY_MIN,
            sellers: SELLER_MIN,
            products: PRODUCT_MIN,
            _switched: false,
            _refreshed: null,
            orderStatus: null,
            ordering: false,
            tripInfo: trip,
            userRole: userRole
        };
    },
    componentWillMount(){
        Dispatcher.dispatch({type: ActionConstants.FRESH_QUOTE_RESULT_LIST});

        Dispatcher.dispatch({type: ActionConstants.SEARCH_PORT_INFO});

        ALikeStore.on(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

        ALikeStore.on(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.on(EventConstants.AJAX_COMMIT_APPLY_COMPLETE, this.on_commitApplyComplete);

        ALikeStore.on(EventConstants.AJAX_ORDER_COMPLETE, this.on_orderComplete);
    },
    componentWillUnmount(){

        ALikeStore.off(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

        ALikeStore.off(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.off(EventConstants.AJAX_COMMIT_APPLY_COMPLETE, this.on_commitApplyComplete);

        ALikeStore.on(EventConstants.AJAX_ORDER_COMPLETE, this.on_orderComplete);
    },
    componentDidMount(){
        var self = this;
        self.__categoryInterval = setInterval(function () {
            var categories = self.state.categories;
            categories = categories + CATEGORY_STEP;
            if (categories > CATEGORY_MAX) {
                categories = CATEGORY_MIN;
            }
            self.setState({categories});
        }, 3000);
        self.__sellerInterval = setInterval(function () {
            var sellers = self.state.sellers;
            sellers = sellers + SELLER_STEP;
            if (sellers > SELLER_MAX) {
                sellers = SELLER_MIN;
            }
            self.setState({sellers});
        }, 1000);
        self.__productInterval = setInterval(function () {
            var products = self.state.products;
            products = products + PRODUCT_STEP;
            if (products > PRODUCT_MAX) {
                products = PRODUCT_MIN;
            }
            self.setState({products});
        }, 1000);
    },
    on_retrieveRecordListComplete(){

        this.setState({_refreshed: new Date()});

        //H5没有默认打开
        var self = this;
        setTimeout(function(){
            //self.handle_setWeekDay();
        },0)
    },
    on_switchQuoteRecordComplete(){

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        var orderStatus = quote.orderStatus;

        if( quote.orderId===0 && quote.orderStatus!== OrderStatus.noOrder.code ){
            return;
        }

        this.setState({
            orderStatus: orderStatus,
            form: quote.isExpired,
            _switched: new Date()
        });
    },
    /**
     * poa显示日期和周几
     */
    handle_setWeekDay(){
        var quteItems = $("#quoteRecordList .quote-record");
        if(quteItems.length){
            quteItems.eq(0).trigger("click");
        }
    },
    on_commitApplyComplete(){
        if (!ALikeStore.get_errorMsg(ActionConstants.COMMIT_APPLY)) {

            var top = $(ReactDOM.findDOMNode(this)).offset().top - $(ElementConstants.TOP_NAV_CLASS).height();

            $(window).scrollTop(top);
        }
    },
    on_orderComplete(){

        this.setState({ordering: false});

        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {

            window.location.href = ALikeStore.get_confirmUrl().mobile;
        }
    },
    on_quoteInvalid(info){
        Dispatcher.dispatch({
            type: ActionConstants.ALERT_QUOTE_BECOME_INVALID,
            data: info
        });
    },
    handle_orderPayment(orderId){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.orderUrl.h5 + '?oid=' + orderId;
        }
    },
    handle_reorder(){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.buyUrl.h5;
        }
    },
    handle_order(){
        var self = this;
        //屏蔽同业代下单
        if(SER_DATA["disableOrder"]){
          window.alert('代用户下单，暂不支持移动端，请到PC下单！');
          return false;
        }

        window.bookDialog.init(function(){
            Dispatcher.dispatch({type: ActionConstants.ORDER});

            self.setState({ordering: true});
        })
    },
    handle_selectQuote(quote){
        var orderStatus  = quote.orderStatus;

        if ( (quote.isExpired || quote.isAllMistake) && !orderStatus) {
            //如果报价过期或者全部缺货,则直接进行调整

            Dispatcher.dispatch({type: ActionConstants.TWEAK_QUOTE, data: quote});
        } else {

            Dispatcher.dispatch({type: ActionConstants.SWITCH_QUOTE_RECORD, data: quote});
        }
    },
    handle_tweak(quote){

        Dispatcher.dispatch({type: ActionConstants.TWEAK_QUOTE, data: quote});
    },
    handle_selectVersion(versionId){

        Dispatcher.dispatch({
            type: ActionConstants.SWITCH_QUOTE_RECORD,
            data: {versionId}
        });
    },
    handle_showIM(){
        var trip = this.state.tripInfo;
        var chatId  = trip.chatId;
        var chatUser  = trip.chatUser;
        var dataId = chatId ? "c"+chatId : chatUser;
        var message = "邦客您好，看到您正在浏览：" + window.location.href + " 您打算什么时候去呢？我们会根据您出行的具体要求，来为您设计最适合您的路线";
        showMobileIM(dataId, message);
    },
    handle_refresh(){

      window.location.reload()

    },
    render(){

        var quoteRecordList = ALikeStore.get_quoteRecordList();

        if (quoteRecordList.length === 0) {
            //如果没有任何返回的时候, 新提交的数据不能定位到当前组件
            //所以, 当没有任何数据时, 返回空的计价结果容器

            return (<div className="quote-record-container feature-profile"></div>);
        }

        var state = this.state;

        var expired = false;

        var orderStatus  = state.orderStatus;

        var currentQuote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        if (!state._switched) {
            //如果没有使用过切换功能,则不设置
            //change: 默认选择一个，以便下面展开显示
            //currentQuote = null;
        }

        if (currentQuote) {

            expired = currentQuote.isExpired;
        }

        var hasBought = ALikeStore.is_tripHasBeenBought();

        return (
            <div className="quote-record-container feature-profile">
                <div className="title">
                    <div className="main">实时价格</div>
                </div>
                <div className="content">
                    <div className="order-hint-info">从下方选取合适价格，即刻预定开始您的超级旅行吧</div>
                    <ul className="quote-record-list">
                        {_.map(quoteRecordList, (record) => {
                            if (record === currentQuote && ((!record.isExpired && !record.isAllMistake) || orderStatus)) {

                                return this.render_quoteRecordDetail(record);
                            } else {

                                return this.render_quoteRecordSummary(record);
                            }
                        })}
                    </ul>
                </div>
            </div>
        );
    },
    /**
     * 判断询价状态,渲染
     */
    render_QuoteStatus: function(quote, version){
        var tripInfo = this.state.tripInfo;
        var hasBought = ALikeStore.is_tripHasBeenBought();

        //计算中
        if(+version.status === QuoteStatus.Calculating.code ){
            return this.render_quoteCalculating(quote, version);
        }

        //价格过期
        if(quote.isExpired ){
            return this.render_priceExpired(quote);
        }

        //全部缺货
        if(quote.isAllMistake){
            return this.render_mistake(quote);
        }

        //需要询价
        if(+version.status === QuoteStatus.Fatal.code  || !version.valid){
            return this.render_failed(quote, version);
        }

        //正常报价
        if(version.valid && (version.status===QuoteStatus.Normal.code || version.status===QuoteStatus.Mistake.code)){
            //计价
            if(quote.inquiryType==1) {
                return this.render_valuation(quote, version);

            }else{
                //报价
                return this.render_enquiry(quote, version);

            }
        }

        return null;

    },
    /**
     * 取得当前记录状态,目前只做真假判断
     * @param quote
     * @returns {boolean}
     * @private
     */
    _getRecordStatus(quote){
        var version = ALikeStore.get_recordDefaultVersion(quote.inquiryKey, true);

        var status = _.findWhere(QuoteStatus.list, {code: +version.status});

        var orderStatus  = quote.orderStatus;
        if ((status === QuoteStatus.Normal) || (status === QuoteStatus.Mistake)) {
            if ((version.valid && !quote.isExpired) || orderStatus) {

                return true
            }else{
                return false
            }
        }else{
                return false
        }
    },
    /**
     * view收起,询价状态
     * @param quote
     * @returns {*}
     */
    render_quoteResultStatus(quote){

        var version = ALikeStore.get_recordDefaultVersion(quote.inquiryKey, true);

        var status = _.findWhere(QuoteStatus.list, {code: +version.status});

        var orderStatus  = quote.orderStatus;

        if ((status === QuoteStatus.Normal) || (status === QuoteStatus.Mistake)) {

            if ((version.valid && !quote.isExpired) || orderStatus) {
                return "￥" + format(quote.amount) + " 元"
            } else {
                return "欢迎询价";
            }
        }
        if( !version.valid ){
            return '欢迎询价';
        }

        return status.text || '欢迎询价';
    },
    /**
     * view收起
     * @param quote
     * @returns {XML}
     */
    render_quoteRecordSummary(quote){
        var trip = ALikeStore.get_tripBasicInfo();
        var recordStatus = this._getRecordStatus(quote);
        return (
            <li className="quote-record" data-startdate={quote.startDate} key={quote.inquiryKey} onClick={()=>{this.handle_selectQuote(quote)}}>
                <div className="title">
                    <div className="start-date"><span className="day">{moment(quote.startDate).format('D')}</span>{moment(quote.startDate).format('MM')}月</div>
                    <div className="quote-info">
                        <div className="start-city">{quote.startCityName}出发</div>
                        <div className="price">{this.render_quoteResultStatus(quote)}</div>
                    </div>
                    <div className="count-down">
                        {
                            hasCountdown(quote)
                                ? <QuoteCountdown quote={ quote } onInvalid={self.on_quoteInvalid}/>
                                : <span>已失效</span>
                        }
                    </div>
                    {
                       ( recordStatus || hasCountdown(quote) )
                            ? <div className="expand-btn"><span>展开</span></div>
                            : <noscript/>
                    }
                </div>
            </li>
        );
    },
    /**
     * 价格日历
     * @param quote
     * @param version
     * @returns {XML}
     */
    rander_quoteCalendar(quote,version){
        var self = this;
        var dataListLen = (quote && quote.priceCalenderDataList) ? quote.priceCalenderDataList.length : 0;
        return (
            <table className="seg-table pack">
                <tbody>
                <tr>
                    {_.map(_.range(0, dataListLen), function (order) {
                        var dayInfo = quote.priceCalenderDataList[order];
                        var date = moment(dayInfo.startDate);

                        if (!dayInfo || !dayInfo.versionId) {
                            return (
                                <td className="version" key={order}>
                                    <div>
                                        <span className="date">{date.format("MM-DD")}</span>
                                        &nbsp;<span className="day">{date.format("dd")}</span>
                                    </div>
                                    <div className="result">
                                        <span className="ask">计算中</span>
                                    </div>
                                </td>
                            );
                        }

                        var selected = false;
                        
                        if( dayInfo.versionId ){
                            selected = dayInfo.versionId === version.versionId;
                        }else{
                            dayInfo.startDate === quote.startDate && (selected = true);
                        }


                        var versionClazz = object2class({
                            'version': true,
                            'selected': selected
                        });
                        return (
                            <td className={versionClazz} key={order}
                                data-startdate={dayInfo.startDate}
                                onClick={()=>{self.handle_selectVersion(dayInfo.versionId)}}>
                                <div>
                                    <span className="date">{date.format("MM-DD")}</span>
                                    &nbsp;<span className="day">{date.format("dd")}</span>
                                </div>
                                <div className="supporter">
                                    {
                                        (+dayInfo.status === QuoteStatus.Mistake.code) ?
                                            (selected) ?
                                                (<i className="icon-m-indicator-lack-r"/>) :
                                                (<i className="icon-m-indicator-lack"/>)
                                            : null
                                    }
                                    {
                                        (dayInfo.startDate === quote.startDate) ?
                                            (<span className="default-day">默认</span>) : null
                                    }
                                </div>
                                <div className="result">
                                    {
                                        (dayInfo.valid && +dayInfo.status!==QuoteStatus.Fatal.code) ?
                                            (<span className="price">￥{format(dayInfo.perPrice)}</span>) :
                                            (dayInfo.status === QuoteStatus.Calculating.code) ?
                                                (<span className="ask">计算中</span>) : (
                                                <span className="ask">欢迎询价</span>)
                                    }
                                </div>
                            </td>
                        );
                    })}
                </tr>
                </tbody>
            </table>
        )

    },
    render_quoteRecordDetail(quote){
        var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());
        var orderStatus  = this.state.orderStatus;

        //var status = this._getQuoteStatus(quote, version);

        //console.log("用户类型:1: 达人, 2: 小帮手,0: 其他(白名单)")
        //console.log("当前用户类型:",userRole)

        //console.log("1:计算中,2:需要询价,3:缺货,4:价格过期,5:已付款,6:修改中,7:日期过期,8:审核未过,9:计价正常,10:报价正常")
        //console.log("当前询价状态:",status)

        return (
            <li className='quote-record expanded record-b' key={quote.inquiryKey}>

                {
                    !orderStatus ? (
                        this.render_QuoteStatus(quote, version)
                    ):(
                        this.render_orderStatus(quote, version)
                    )
                }

            </li>
        );
    },
    /**
     * 展开
     * 出行条件 detail > 条件
     * @param quote
     * @returns {XML}
     */
    render_quoteConditionList(quote, version ,isShowCalendar){
        var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());
        var trip = ALikeStore.get_tripBasicInfo();
        var isShowCalendar = _.isBoolean(isShowCalendar) ? isShowCalendar : false;
        var startDate = quote.buyDate !== "" ? quote.buyDate : quote.startDate;
        return(
            <div>
                <div className="seg title">
                    <label>{moment(startDate).format("MMMDo")} {quote.startCityName}出发 {_.findWhere(TripGrade.list, {code: +quote.grade}).name}</label>
                    <div className="compare-btn js-compare-btn"><span className="icon">+</span>对比</div>
                </div>
                <div className="seg info">

                    { quote.inquiryType === 2 || !isShowCalendar ? null: this.rander_quoteCalendar(quote, version) }

                    <div className="seg-item"><label>出行城市:</label>{quote.startCityName} {startDate}</div>
                    <div className="set-item"><label>人员构成:</label>{quote.adtCnt}成人,{quote.chdCnt}儿童,{quote.roomCnt}间房{trip.hasCar ? `,${quote.carCnt}辆车` : null}</div>
                </div>
            </div>
        )
    },
    render_tweak(quote){
        return(
            <div className="tweak" onClick={()=>{this.handle_tweak(quote)}}>重新调整</div>
        )
    },
    /**
     * 计价/报价结果
     * @param quote
     * @param version
     */
    render_quoteResultInfo(quote, version){
        var self = this;
        var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());
        var trip = ALikeStore.get_tripBasicInfo();
        var ordering = this.state.ordering;
        var errorCode = ALikeStore.get_errorCode(ActionConstants.ORDER);
        if(errorCode === 900 || errorCode === 9900){
            var referer = window.location.href;
            window.location.href = "//m.xcds.com.cn/login/?referer="+referer;
            return;
        }
        return (
            <div>
                {this.render_quoteConditionList(quote, version, true)}
                {this.render_tweak(quote)}
                { (version.price>0 && +version.status!==QuoteStatus.Fatal.code) ?
                    (
                        <div className="seg price-seg">
                            <div style={{paddingBottom: '.24rem'}}>
                                <label>人均:</label>
                                <span className="price">{format(version.perPrice)}</span> 元 / 人
                                (总价：¥{format(version.amount)})
                            </div>
                            {ALikeStore.get_lastCommitVersion() === version.versionId ? (<div
                                className="error-msg">{ALikeStore.get_errorMsg(ActionConstants.ORDER)}</div>) : null}

                            {
                                !ordering ? (
                                    <button className="book" onClick={self.handle_order}>开始预定</button>
                                ) : (
                                    <button className="book">预定中… </button>
                                )
                            }
                        </div>
                    ) : null
                }
                <div className="hint-info m-f-28">本产品为全自动实时计价产品，不能进行单品价格的拆分。有任何问题，可以联系旅行顾问</div>
                <div className="double-btns cell-btn-wrap">
                    {this.render_contact(false, true)}
                </div>
            </div>
        )
    },
    /**
     * 已提交计算中
     */
    render_quoteCalculating: function(quote, version){
        var self = this;
        var state = self.state;
        return(
            <div>
                {this.render_quoteConditionList(quote, version, true)}
                {this.render_tweak(quote)}

                <div className="version-op">
                    <div className="strong-hint c-orange text-center">
                        <img className="loading" src="//f5.jiejiatech.net/y16/0617/1624/00eqg_o.gif" width="24" alt=""/>
                        计算中...
                    </div>
                    <div className="calculating-hint">
                        行程大师正在对
                        <span className="c-orange">{self.state.categories}</span>
                        个品类的
                        <span className="c-orange">{self.state.sellers}</span>
                        家认证商户，
                        <span className="c-orange">{self.state.products}</span>
                        件产品进行计算，请耐心等待，
                        <span className="c-orange">计算结果将在4小时内短信通知您</span>
                        ，请注意查收。计算完成后，
                        <a className="calculating-refresh c-blue" onClick={this.handle_refresh}>刷新本页</a>即可查看。
                    </div>
                    <div className="hint-info m-f-28">正在计价中，请耐心等待，有任何问题可以联系旅行顾问</div>
                    <div className="double-btns cell-btn-wrap">
                        {this.render_contact(true, true)}
                    </div>
                </div>
            </div>

        )
    },

    /**
     * 计算完成-全部缺货
     */
    render_mistake: function(){

        return(
            <div>
                <div className="quote-wait">
                    <i className="icon-m-indicator-wait"></i>
                    <div className="wait-txt f-l">多日期旅行产品库存紧张，请联系旅行顾问询价</div>
                </div>
                <div className="strong-hint c-orange text-center">欢迎询价.</div>
                <PriceRatioButton/>
                <div className="hint-info m-f-26">该出发日期缺少<a href="#absentProductList" id="link-key" className="js-anchor">关键产品</a>，将会影响行程安排，请联系旅行顾问询价</div>
                <div className="double-btns cell-btn-wrap">
                    {this.render_contact(true, true)}
                </div>
            </div>
        )
    },
    /**
     * 价格过期失效
     */
    render_priceExpired: function(quote){

        return(
            <div>
                {this.render_quoteConditionList(quote, null)}
                {this.render_tweak(quote)}
                <div>
                    <div className="strong-hint c-orange text-center">价格已过期.</div>

                    <div className="hint-info m-f-28">因为机票等旅行产品价格波动，为保证获得最佳价格，请重新计价</div>
                    <div className="double-btns cell-btn-wrap">
                        {this.render_contact(true, true)}
                    </div>

                </div>
            </div>
        )
    },
    /**
     * 计算失败,需要询价
     */
    render_failed: function(quote, version){

        return(
            <div>
                {this.render_quoteConditionList(quote, version, true)}
                {this.render_tweak(quote)}
                <div>
                    <div className="strong-hint c-orange text-center">欢迎询价</div>
                    <PriceRatioButton/>
                    <div className="hint-info m-f-28">出发日期缺少<a href="#absentProductList" id="link-key" className="js-anchor">关键产品</a>，将会影响行程安排，请联系旅行顾问询价</div>
                    <div className="double-btns cell-btn-wrap">
                        {this.render_contact(false, true)}
                    </div>

                </div>
            </div>
        )
    },

    /**
     * 已付款
     */
    render_deal: function(quote){
        return(
            <div>
                {this.render_quoteConditionList(quote, version)}
                <div>
                    <div className="strong-hint c-orange text-center">已预定成功.</div>
                    <div className="double-btns cell-btn-wrap">
                        {this.render_contact(false, true)}
                    </div>
                </div>
            </div>
        )
    },

    /**
     * 计价--正常
     */
    render_valuation: function(quote, version){
        return this.render_quoteResultInfo(quote, version);
    },
    /**
     * 报价--正常
     */
    render_enquiry: function(quote, version){
        return this.render_quoteResultInfo(quote, version);
    },
    /**
     * 报价/记价状态
     * @param quote
     * @param version
     * @returns {XML}
     */
    render_orderStatus(quote, version){
        var orderStatus  = this.state.orderStatus;
        return(
            <div>
                {this.render_quoteConditionList(quote, version, false)}
                {this.render_orderDetail(quote, version)}

                <div className="hint-info m-f-28">本产品为全自动实时计价产品，不能进行单品价格的拆分。有任何问题，可以联系旅行顾问</div>
                {
                    orderStatus === OrderStatus.waitingForPay.code ? (
                        <div className="double-btns cell-btn-wrap">
                            {this.render_contact(true, true)}
                        </div>
                    ) : null
                }

            </div>
        )
    },
    /**
     * 报价/记价状态--->结果
     * @param quote
     * @param version
     * @returns {XML}
     */
    render_orderDetail(quote,version){

        var self = this;
        var state = self.state;
        return (
            <div>
                { (version.price>0 && +version.status!==QuoteStatus.Fatal.code) ?
                    (
                        <div className="seg price-seg">
                            <div style={{paddingBottom: '.24rem'}}>
                                <label>人均:</label>
                                <span className="price">{format(version.perPrice)}</span> 元 / 人
                                (总价：¥{format(version.amount)})
                            </div>
                            {this.render_orderButton(quote, version)}
                        </div>
                    ) : null
                }
            </div>
        )
    },
    /**
     * 渲染状态
     * @param quote
     * @returns {XML}
     */
    render_orderButton(quote){
        var self = this;
        var state = self.state;
        var ordering = state.ordering;
        var orderStatus  = state.orderStatus;
        //var orderStatus  = 4
        //console.log("订单状态...",orderStatus)
        return(
            <div>

                {(() => {
                    switch (orderStatus) {
                        case OrderStatus.waitingForPay.code:
                            return (
                                <div className="double-btns cell-btn-wrap">
                                    <div className="c-wrap">
                                        <button className="bt-second c-btn" onClick={self.handle_reorder}>
                                            关闭已下预定单
                                        </button>
                                    </div>
                                    <div className="c-wrap">
                                        <button className="book c-btn"
                                                onClick={()=>{self.handle_orderPayment(quote.orderId)}}>
                                            已下预定单，立即付款
                                        </button>
                                    </div>
                                </div>
                            );
                            break;

                        case OrderStatus.partPayed.code:
                            return(
                                <div>
                                    <div className="strong-hint c-orange text-center">已付定金</div>
                                    <div className="double-btns cell-btn-wrap">
                                        {self.render_im()}
                                        <div className="c-wrap">
                                            <button className="book" onClick={ ()=>{self.handle_orderPayment(quote.orderId)}}>支付尾款</button>
                                        </div>
                                    </div>
                                </div>
                            );
                            break;

                        case OrderStatus.fullPayed.code:
                            return(
                                <div>
                                    <div className="strong-hint c-orange text-center">已付全款</div>
                                    <div className="double-btns cell-btn-wrap">
                                        {self.render_im()}
                                        <div className="c-wrap">
                                            <button className="book"  onClick={ self.handle_reorder }>查看订单状态</button>
                                        </div>
                                    </div>
                                </div>
                            )
                            break;

                        case OrderStatus.tradeClose.code:
                            return(
                                <div>
                                    <div className="strong-hint c-orange text-center">交易关闭</div>
                                    <div className="double-btns cell-btn-wrap">
                                        {self.render_im()}
                                        <div className="c-wrap">
                                            <button className="book" onClick={ self.handle_reorder }>查看订单状态</button>
                                        </div>
                                    </div>
                                </div>
                            )
                            break;

                        default:
                            return null;
                    }
                })()}
            </div>
        )
    },
    /**
     * 联系方式
     * @returns {XML}
     */
    render_contact(isShowTel, isShowIM){
        var trip = this.state.tripInfo;
        var chatId  = trip.chatId;
        var chatUser  = trip.chatUser;
        var dataId = chatId ? chatId : chatUser;

        var isShowTel = isShowTel || false;
        var isShowIM = isShowIM || false;
        var wrapClazz = object2class({
            'c-wrap': true,
            'c-wrap-w': !isShowTel || !isShowIM
        });
        return(
            <div>
                {isShowTel? (
                    <div className={wrapClazz}><a href="tel:4006-86-5060"><button className="vm-wrapper tel text-center">4006-86-5060</button></a></div>
                ) : null}

                {isShowIM ? (
                    <div className={wrapClazz}><button className="vm-wrapper online-talk text-center" onClick={this.handle_showIM} data-id={dataId}>在线咨询</button></div>
                ): null}
            </div>
        )
    },
    /**
     * 渲染IM按钮
     * @returns {XML}
     */
    render_im(){
        var trip = this.state.tripInfo;
        var chatId  = trip.chatId;
        var chatUser  = trip.chatUser;
        var dataId = chatId ? chatId : chatUser;
        return(
            <div className="c-wrap"><button className="vm-wrapper online-talk text-center" onClick={this.handle_showIM} data-id={dataId}>在线咨询</button></div>
        )
    }
});
 



/** WEBPACK FOOTER **
 ** ./script/detail-m/QuoteRecordList.jsx
 **/